import React from 'react';
import { TarotCard } from './TarotCard';
import { TarotCardData } from '../types/tarot';

interface CardFanProps {
  cards: TarotCardData[];
  selectedCards: TarotCardData[];
  onCardSelect: (card: TarotCardData) => void;
  disabled?: boolean;
  onFanInteract?: () => void;
}

export const CardFan: React.FC<CardFanProps> = ({
  cards,
  selectedCards,
  onCardSelect,
  disabled = false,
  onFanInteract,
}) => {
  const displayCards = cards.slice(0, 8); // Show 8 cards in the fan

  return (
    <div className="fixed bottom-0 left-0 right-0 pb-6 pt-4 px-1 z-10">
      <div className="relative flex justify-center items-end h-72">
        {displayCards.map((card, index) => {
          // FIXED: Disable selection highlighting when reading is complete to prevent purple border bug
          const isReadingComplete = selectedCards.length >= 3;
          const isSelected = !isReadingComplete && selectedCards.some(selected => selected.id === card.id);
          const totalCards = displayCards.length;
          const angle = ((index - (totalCards - 1) / 2) * 22); // Even wider spread
          const translateX = (index - (totalCards - 1) / 2) * 20; // More horizontal spread
          const translateY = Math.abs(index - (totalCards - 1) / 2) * 10; // More pronounced curve
          
          return (
            <div
              key={card.id}
              className="absolute w-32 sm:w-36 aspect-[2/3]"
              style={{
                transform: `
                  translateX(${translateX}px) 
                  translateY(${translateY}px) 
                  rotate(${angle}deg)
                `,
                zIndex: isSelected ? 20 : 10,
                transformOrigin: 'center bottom'
              }}
              onPointerDown={() => onFanInteract?.()}
            >
              <TarotCard
                card={card}
                isSelected={isSelected}
                onClick={() => {
                  onFanInteract?.();
                  onCardSelect(card);
                }}
                className="w-full h-full"
                disabled={disabled}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
